import React, { useState, useEffect, useMemo } from 'react';
import { STATUS_CODES } from 'app/config/status';
import { useSelector } from 'react-redux';
import Alert from '@material-ui/lab/Alert';
import alertsEndpoint from 'app/api/services/alertsEndpoint';
import moment from 'moment';
import helpers from 'app/utils/helpers';
import notification from 'app/config/notification';
import { SERVICES_CODES } from "../../config/services";

function AlertMessage({ isInternalForm }) {
  const request = useSelector(state => state.requests.details);
  const service = useSelector(state => state.services.details);
  const actualRevision = useSelector(state => state.revisions.details);
  const revisions = useSelector(state => state.revisions.revisions);

  const alertMessageStore = useSelector(state => state.forms.alertMessage);

  const [alertMessage, setAlertMessage] = useState();
  const [isAlertCertification, setIsAlertCertification] = useState(false);
  const [hasAlert, setHasAlert] = useState(false);

  useEffect(() => {
    const init = () => {
      if (
        alertMessageStore.cdServico &&
        alertMessageStore.cdServico === service.cdServico &&
        alertMessageStore.message
      ) {
        setIsAlertCertification(true);
        setHasAlert(true);
        setAlertMessage(alertMessageStore.message);
      }
    };
    init();
  }, [alertMessageStore, service.cdServico]);

  useEffect(() => {
    const init = async () => {
      if (
        request.cdSituacao &&
        (request.cdSituacao === STATUS_CODES.CANCELADO ||
          request.cdSituacao === STATUS_CODES.REPROVADO)
      ) {
        if (request.deJustificativa && request.deJustificativa !== '') {
          setAlertMessage(request.deJustificativa);
          setHasAlert(true);
        }
      } else if (
        (service.cdServico === SERVICES_CODES.ALTERACAO_VEICULOS
          || service.cdServico === SERVICES_CODES.ALTERACAO_VEICULOS_SEM_CRC)
        && (request.deJustificativa && request.deJustificativa !== '')
      ) {
        setAlertMessage(request.deJustificativa);
        setHasAlert(true);
      } else if (
        !isInternalForm &&
        request.cdSituacao &&
        request.cdSituacao === STATUS_CODES.AGUARDANDO_RESOLUCAO_PENDENCIAS
      ) {
        try {
          const response = await alertsEndpoint.getAlert({ cdSolicitacao: request.cdSolicitacao });
          if (response.status === 200 && response.data) {
            const alert = response.data;
            setHasAlert(true);
            if (alert.deAlerta) {
              setAlertMessage(alert.deAlerta);
            }
          }
        } catch (error) {
          notification('Erro de comunicação. Tente novamente.', {
            toastId: 'SERVER_ERROR',
            type: 'error',
          });
        }
      }
    };

    init();
  }, [isInternalForm, request, service]);

  const deadLineDate = useMemo(() => {
    if(request.cdSituacao === STATUS_CODES.REPROVADO || request.cdSituacao === STATUS_CODES.CANCELADO){
      return null;
    }
    return helpers.extractDateFromRevisions(revisions, actualRevision);
  }, [actualRevision, request.cdSituacao, revisions]);

  return (
    <>
      {hasAlert && (
        <Alert severity="warning">
          {!isAlertCertification && (
            <>
              {request.situacao?.deSituacao}:{" "}
              {deadLineDate &&
                deadLineDate !== '' &&
                ` Data limite: ${moment.utc(deadLineDate).format('DD/MM/YYYY')}. `}
            </>
          )}
          {alertMessage}
        </Alert>
      )}
    </>
  );
}

export default AlertMessage;
